import { call, select } from 'redux-saga/effects'
import { optimisticPut } from 'utils/sagas'
import { action as apiAction } from 'api/Api'
import {
  removeArray
} from '../redux/followedCards'

export default function * requestUnfollowCardsFromBoard (action) {
  const { boardId } = action.payload

  const state = yield select()

  const followedCardIds = state.kanbo.followedCards.followedCardIds
  const followedCardById = state.kanbo.followedCards.followedCardsById

  let cardIds = []
  let names = []

  followedCardIds
    .map(id => followedCardById[id])
    .forEach(followedCard => {
      if (followedCard.boardId === boardId) {
        cardIds.push(followedCard.id)
        names.push('card-' + followedCard.id)
      }
    })

  const optimisticAction = yield optimisticPut(removeArray(cardIds))

  try {
    yield call(apiAction, 'RemoveObservedTags', {
      names
    })

    yield optimisticAction.commit()
  } catch (error) {
    yield optimisticAction.revert()

    throw error
  }
}
